<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <h2>
      Uredite skupino:
    </h2>

    <CategoryForm
      @save="save"
      @cancel="cancel"
      :category="category"
    />
    <div class="row mt-10">
      <div class="col">
        <h2>
          Lokacije tiskanja:
        </h2>
      </div>
      <div class="col">
        <PopupPickerLokacijeTiskanjaSkupine
          :categoryId="id"
          :levelArticles="localPrinters"
          :allArticles="allPrinters"
        />
      </div>
    </div>
    <v-row>
      <v-col>
        <v-simple-table fixed-header>
          <template v-slot:default>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row v-dragula="localPrinters" drake="printers">
      <v-col cols="12" v-for="item of localPrinters" :key="item.id" class="pt-0 pb-0">
        <TitleOnlyCard
          :title="item.name"
          :editable="false"
          :deleteable="true"
          :draggable="false"
          @delete="izbrisiLokacijoPrinterja(item)"
        />
      </v-col>
    </v-row>
    <div class="row mt-10">
      <div class="col">
        <h2>
          Skupine dodatkov:
        </h2>
      </div>
      <div class="col">
        <PopupPickerPodskupine
          :categoryId="id"
          :levelCategories="localSubcategories"
          :allCategories="categories"
          subcategoryType="1"
        />
      </div>
    </div>
    <v-row>
      <v-col>
        <v-simple-table fixed-header>
          <template v-slot:default>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row v-dragula="localPrinters" drake="subcategories">
      <v-col cols="12" v-for="item of localSubcategories" :key="item.id" class="pt-0 pb-0">
        <TitleOnlyCard
          :title="item.name"
          :editable="false"
          :deleteable="true"
          :draggable="false"
          @delete="izbrisiPodakategorijo(item)"
        />
      </v-col>
    </v-row>
    <div class="row mt-10">
      <div class="col">
        <h2>
          Artikli:
        </h2>
      </div>
      <div class="col">
        <v-btn
          color="#0F998E"
          class="white--text float-right"
          @click="saveOrder"
        >
          Shrani vrstni red
          <v-icon right dark>mdi-check</v-icon>
        </v-btn>
        <v-btn
          color="#0F998E"
          class="white--text float-right mr-5"
          @click="sortAbc"
        >
          Po abecedi
          <v-icon right dark>mdi-sort-alphabetical</v-icon>
        </v-btn>
      </div>
    </div>
    <v-row>
      <v-col>
        <PopupPickerPodskupine
          text="Dodaj skupino"
          :categoryId="id"
          :levelCategories="localArticles"
          :allCategories="categories"
          subcategoryType="2"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-simple-table fixed-header>
          <template v-slot:default>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row v-dragula="localArticles" drake="articles">
      <v-col cols="12" v-for="(item, index) of localArticles" :key="item.id" class="pt-0 pb-0">
        <!-- {{ item.sort_order }} {{  item.id }}
        {{ index }}
        {{ item.sort_order }}
        {{ item.id }}
        <div v-if="item.type === 2">{{ item }}</div> -->
        <TitleOnlyCard
          :title="item.name"
          :editable="false"
          :deleteable="item['type'] === 2"
          :draggable="true"
          @delete="izbrisiPodakategorijo(item)"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapActions } from 'vuex'
import { saveItem } from '@/utils/crudFunctions'
import CategoryForm from '@/components/CategoryForm'
import PopupPickerLokacijeTiskanjaSkupine from '@/components/PopupPickerLokacijeTiskanjaSkupine'
import PopupPickerPodskupine from '@/components/PopupPickerPodskupine'
import TitleOnlyCard from '@/components/TitleOnlyCard'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import { objectToArray } from '@/utils/object'

export default {
  components: {
    CategoryForm,
    TitleOnlyCard,
    PopupPickerLokacijeTiskanjaSkupine,
    PopupPickerPodskupine
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    id: {
      required: true,
      type: Number
    }
  },
  data () {
    return {
      localArticles: [],
      changedModel: [],
      localPrinters: [],
      localSubcategories: [],
      localCategorySubcategories: [],
      koncano: false,
    }
  },
  computed: {
    localniArticles () {
      return this.changedModel
    },
    category () {
      return this.$store.state.categories.items[this.id]
    },
    subcategories () {
      return objectToArray(this.$store.state.categories.podKategorije[this.id])
    },
    categories () {
      return objectToArray(this.$store.state.categories.items)
    },
    articles () {
      return this.$store.state.categories.articles
    },
    allPrinters () {
      return objectToArray(this.$store.state.printerslocations.items)
    },
    printerjiLokacijSkupin () {
      return objectToArray(this.$store.state.printerslocations.groupPrinters[this.id])
    }
  },
  methods: {
    ...mapActions('categories', ['loadItem', 'saveItem', 'getArticles', 'getSubcategories', 'deleteSubcategory', 'updateArticlesSubcategory']),
    ...mapActions('articles', ['updateArticlesOrder']),
    ...mapActions('printerslocations', ['getCategoryLocationPrinters', 'deleteCategoryLocationPrinter']),
    ...mapActions('printerslocations', { naloziPrinerje:'loadItems' }),
    izbrisiPodakategorijo (item) {
      const subcategoryId = item.id
      const categoryId = this.category.id
      const typeId = item.type
      this.deleteSubcategory({ categoryId, subcategoryId, typeId })
        .then(() => console.log('izbrisano'))
        .catch((err) => console.log(err.message))
    },
    izbrisiLokacijoPrinterja (item) {
      const LocationId = item.id
      const categoryId = this.category.id
      this.deleteCategoryLocationPrinter({ categoryId, LocationId })
        .then(() => console.log('izbrisano'))
        .catch((err) => console.log(err.message))
    },
    save ({ data }) {
      saveItem(data, '-1', this)
    },
    cancel () {
      this.$router.push({ name: 'MyCompanyCategories' })
    },
    saveOrder () {
      const updatesArticles = []
      const updatesSubgroupsAsArticles = []
      // console.log(this.localArticles)
      this.localArticles.forEach((item, i) => {
        // console.log(item.name, i)
        if (!item.type) {
          updatesArticles.push({
            id: item.id,
            sort_order: i + 1
          })
        } else {
          updatesSubgroupsAsArticles.push({
            id: item.id,
            sort_order: i + 1,
            type: item.type
          })
        }
      })
      // console.log(updatesArticles, updatesSubgroupsAsArticles)
      this.updateArticlesOrder(updatesArticles)
        // console.log(updatesSubgroupsAsArticles)
        if (updatesSubgroupsAsArticles.length) {
          this.updateArticlesSubcategory({ updates: updatesSubgroupsAsArticles, categoryId: this.id })
        }
    },
    sortAbc () {
      this.localArticles.sort((a, b) => (a.name > b.name) ? 1 : -1)
    }
  },
  created () {
    this.loadItem(this.id)
      .then(item => {
        this.getArticles(this.id)
          .then(items => {
            // this.localArticles = this.articles.sort((a, b) => (a.sort_order > b.sort_order) ? 1 : -1)
            const category = this.category
            this.getCategoryLocationPrinters({ category })
              .then((usp) => {
                this.localPrinters = usp[category.id]
                this.naloziPrinerje()
                  .then((uspesno) => {
                    this.getSubcategories(this.id)
                      .then((podkategorije) => {
                        this.localSubcategories = podkategorije[category.id].filter(category => category.type === 1)
                        this.localArticles = [ ...this.articles, ...podkategorije[category.id].filter(category => category.type === 2) ].sort((a, b) => (a.sort_order > b.sort_order) ? 1 : -1)
                        this.asyncDataStatus_fetched()
                        this.koncano = true

                        this.$dragula.$service.eventBus.$on('dropModel', ({ sourceModel, dragIndex, dropIndex }) => {
                          console.log(dragIndex, dropIndex)
                          this.changedModel = sourceModel.model
                          console.log('sourceModel: ', sourceModel.model)
                            /* for (const [index, art] in sourceModel.model) {
                              Vue.set(this.localArticles, index, { ...art, sort: index, sort_order: index + 1})
                              // return { ...art, sort: index, sort_order: index + 1}
                            } */
                            // console.log(this.localArticles)
                            // this.localArticles.splice(dropIndex, 0, self.entries.splice(dragIndex, 1)[0]);
                        })
                      })
                  })

              })
          })
      })

  },
  watch: {
    $router (to, from) {
      this.$dragula.$service.eventBus.$off('dropModel')
    },
    printerjiLokacijSkupin (newSkupino) {
      if (this.koncano) {
        this.localPrinters = newSkupino
      }
    },
    subcategories (newSubcategories) {
      if (this.koncano) {
        // console.log('nedelja?', newSubcategories)
        this.localSubcategories = newSubcategories.filter(category => category.type === 1)
        // newSubcategories = newSubcategories.map(cursub => ({ ...cursub, sort: cursub.sort_order }))
        this.localArticles = [ ...this.articles, ...newSubcategories.filter(category => category.type === 2) ].sort((a, b) => (a.sort_order > b.sort_order) ? 1 : -1)
        console.log('lA: ', this.localArticles)
      }
    },
    localniArticles: {
      handler (newLost) {
        // this.localArticles = newLost
        // console.log('nana: ', newLost)
        this.localArticles = newLost.map((nL, index) => ({ ...nL, sort: index, sort_order: index + 1 }))
      },
      immediate: false
    }
  }
}
</script>
